import AngryFace from '@/assets/face-angry.svg?react';
import SadFace from '@/assets/face-sad.svg?react';
import FineFace from '@/assets/face-fine.svg?react';
import HappyFace from '@/assets/face-happy.svg?react';
import OverjoyedFace from '@/assets/face-overjoyed.svg?react';
import LineIcon from '@/assets/shape-line.svg?react';
import ArrowLineIcon from '@/assets/shape-line-directional.svg?react';
import CircleIcon from '@/assets/shape-circle.svg?react';
import SquareIcon from '@/assets/shape-square.svg?react';
import TriangleIcon from '@/assets/shape-triangle.svg?react';
import ParabolaIcon from '@/assets/shape-parabola.svg?react';
import PentagonIcon from '@/assets/shape-pentagon.svg?react';
import HexagonIcon from '@/assets/shape-hexagon.svg?react';
import OcatagonIcon from '@/assets/shape-octagon.svg?react';
import TwoDgraph from '@/assets/shape-2d-graph.svg?react';
import ThreeDgraph from '@/assets/shape-3d-graph.svg?react';
import Conegraph from '@/assets/shape-cone.svg?react';
import Cubegraph from '@/assets/shape-cube.svg?react';
import Cylindergraph from '@/assets/shape-cylinder.svg?react';

export const COLORS = {
  PEN: {
    default: '#f8f8f8',
    black: '#262626',
    silver: '#c0c0c0',
    gray: '#808080',
    red: '#ff0000',
    maroon: '#800000',
    yellow: '#ffff00',
    olive: '#808000',
    lime: '#00ff00',
    green: '#008000',
    aqua: '#00ffff',
    teal: '#008080',
    blue: '#0000ff',
    navy: '#000080',
    fuchsia: '#ff00ff',
    purple: '#800080'
  },
  HIGHLIGHTER: {
    default: 'rgba(225, 203, 5, 0.7)',
    blue: 'rgba(39, 152, 177, 0.7)',
    purple: 'rgba(234, 151, 255, 0.7)',
    green: 'rgba(100, 255, 75, 0.7)',
    orange: 'rgba(255, 172, 75, 0.7)'
  },
  BACKGROUND: {
    black: '#000000',
    white: '#ffffff',
    white1: '#f5f5f5',
    white2: '#e7ecef',
    white3: '#e5e6e4',
    blue: '#235af3',
    red: '#dc2804',
    green: '#05945b',
    pink: '#d02670',
    teal: '#08767e',
    orange: '#fd853a',
    purple: '#6e42e5'
  },
  WHITEBOARD: {
    gray: '#363636'
  },
  GRID: 'gray'
};

export const TOOLS = {
  SELECT: 'select',
  LASER: 'laser',
  PEN: 'pen',
  ERASER: 'eraser',
  HIGHLIGHTER: 'highlighter',
  SHAPES: {
    TWO_D: {
      LINE: 'line',
      PARABOLA: 'parabola',
      RECTANGLE: 'rectangle',
      CIRCLE: 'circle',
      TRIANGLE: 'triangle',
      PENTAGON: 'pentagon',
      HEXAGON: 'hexagon',
      OCTAGON: 'octagon',
      TWO_D_GRAPH: 'twoDgraph',
      THREE_D_GRAPH: 'threeDgraph',
      ARROW: 'arrowline'
    },
    THREE_D: {
      CUBE: 'cuboid',
      CONE: 'cone',
      CYLINDER: 'cylinder'
    }
  },
  TEXT: 'text',
  BACKGROUND: 'background',
  IMAGE: 'image',
  QUIZ: 'quiz',
  POLL: 'poll'
};

export const LINEWIDTH = {
  PEN: {
    small: 2,
    medium: 4,
    large: 6
  },
  HIGHLIGHTER: {
    small: 16,
    medium: 18,
    large: 24
  },
  ERASER: {
    small: 16,
    medium: 36,
    large: 60
  },
  DEFAULT: 2
};

export const SHAPES_2D = [
  { tool: TOOLS.SHAPES.TWO_D.LINE, Icon: LineIcon },
  { tool: TOOLS.SHAPES.TWO_D.ARROW, Icon: ArrowLineIcon },
  { tool: TOOLS.SHAPES.TWO_D.RECTANGLE, Icon: SquareIcon },
  { tool: TOOLS.SHAPES.TWO_D.CIRCLE, Icon: CircleIcon },
  { tool: TOOLS.SHAPES.TWO_D.TRIANGLE, Icon: TriangleIcon },
  { tool: TOOLS.SHAPES.TWO_D.PARABOLA, Icon: ParabolaIcon },
  { tool: TOOLS.SHAPES.TWO_D.PENTAGON, Icon: PentagonIcon },
  { tool: TOOLS.SHAPES.TWO_D.HEXAGON, Icon: HexagonIcon },
  { tool: TOOLS.SHAPES.TWO_D.OCTAGON, Icon: OcatagonIcon },
  { tool: TOOLS.SHAPES.TWO_D.TWO_D_GRAPH, Icon: TwoDgraph },
  { tool: TOOLS.SHAPES.TWO_D.THREE_D_GRAPH, Icon: ThreeDgraph }
];

export const SHAPES_3D = [
  { tool: TOOLS.SHAPES.THREE_D.CONE, Icon: Conegraph },
  { tool: TOOLS.SHAPES.THREE_D.CUBE, Icon: Cubegraph },
  { tool: TOOLS.SHAPES.THREE_D.CYLINDER, Icon: Cylindergraph }
];

export const STUDENT_STAR_RATING = [
  { value: 1, Icon: AngryFace, color: '#ff4545', label: 'Very Bad' },
  { value: 2, Icon: SadFace, color: '#ffa534', label: 'Poor' },
  { value: 3, Icon: FineFace, color: '#ffe234', label: 'Satisfactory' },
  { value: 4, Icon: HappyFace, color: '#b7dd29', label: 'Good' },
  { value: 5, Icon: OverjoyedFace, color: '#57e32c', label: 'Excellent' }
];

export const EMOJIS = ['👍', '👎', '✅', '👏', '🎉', '💯', '➕'];

export const STUDENT_DETAILED_RATING = [
  { label: 'Overall teaching knowledge', stars: 5 },
  { label: 'Concept delivery', stars: 5 },
  { label: 'Overall teaching standard', stars: 5 }
];

export const STUDENT_TECHNICAL_RATING = [
  { label: 'Audio Problem', key: 'Audio' },
  { label: 'Video Problem', key: 'Video' },
  { label: 'Writing Lag issues', key: 'Writing Lag' },
  { label: 'Persistent A/V issues', key: 'Audio Video' }
];

export const TEACHER_DETAILED_RATING = [{ stars: 5 }];

export const FEEDBACK_CONFIRMATION = [
  {
    heading: 'Apologies for the bad experience!',
    subHeading: "We've received your feedback and have already started working on it",
    color: '#db6d24',
    Icon: FineFace
  },
  {
    heading: 'Thank you for letting us know the feedback',
    subHeading: 'We constantly work on our customer feedbacks and make their experience better',
    color: '#05945b',
    Icon: HappyFace
  },
  {
    heading: 'We are glad that you liked our platform',
    subHeading: 'We ensure to keep providing you this experience always',
    color: '#05945b',
    Icon: OverjoyedFace
  }
];

export const TOOLS_CLASSES = {
  select: '',
  pen: 'pen',
  eraser: 'eraser',
  highlighter: 'highlighter',
  laser: 'laser',
  line: 'shape',
  parabola: 'shape',
  threeDgraph: 'shape',
  twoDgraph: 'shape',
  rectangle: 'shape',
  circle: 'shape',
  triangle: 'shape',
  pentagon: 'shape',
  hexagon: 'shape',
  octagon: 'shape',
  arrowline: 'shape',
  cuboid: 'shape',
  cone: 'shape',
  cylinder: 'shape'
};

export const FIREWALLS = [
  {
    url: import.meta.env.VITE_PUBLIC_CRYSTAL_API_URL + '/health',
    display: {
      name: 'API Server',
      description: 'Connect to the API Servers',
      result: {
        success: 'Successful',
        error: 'Error',
        warning: 'Warning'
      },
      error: 'Please contact your administrator to grant access.',
      warning: {
        secure: 'You can only connect to API server over secure connection.',
        nonSecure: 'You can only connect to API Servers over non-secure connection.'
      }
    }
  },
  {
    url: import.meta.env.VITE_PUBLIC_NODE_URL + '/health',
    display: {
      name: 'Live Server',
      description: 'Connect to the Live Servers',
      result: {
        success: 'Successful',
        error: 'Error',
        warning: 'Warning'
      },
      error: 'Please contact your administrator to grant access.',
      warning: {
        secure: 'You can only connect to Live server over secure connection.',
        nonSecure: 'You can only connect to Live Servers over non-secure connection.'
      }
    }
  }
];

export const virtualBackgrounds = ['/blackvbg.png', '/whitevbg.png'];
